import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetDevices = ApiClient['v5']['devices']['$get'];
type DeviceListQuery = InferRequestType<GetDevices>['query'];
type DeviceListResponse = InferResponseType<GetDevices, 200>;

export function useDevices(params: DeviceListQuery = {}) {
  return useFetch<DeviceListResponse>(
    `devices?${JSON.stringify(params)}`,
    (client) => client.v5.devices.$get({ query: params }),
    undefined,
    { keepPreviousData: true }
  );
}
